import React, { useEffect, useState } from 'react';
import { ModalDescriptionProposal } from './components/modalDescriptionProposal';
import { useAuth } from '../../../../../../modules/auth';
import { KTSVG } from '../../../../../../../_metronic/helpers';
import { putProposalOne } from '../../../../../../services/proposalsService';
import { useToast } from '../../../../../components/Toats';
import { useFormik } from 'formik';
import * as Yup from "yup";


type Props = {
  itemProposal: any;
  refresh: any
}
const validationSchema = Yup.object().shape({
  description: Yup.string()
});

export function DescriptionProposal({itemProposal, refresh} : Props) {
    const [loading, setLoading] = useState()
    const [showModalDescriptionOS, setShowModalDescriptionOS] = useState<boolean>(false)
    const [loadingUpdateProposal, setLoadingUpdateProposal] = useState<boolean>(false)
    const {currentUser} = useAuth()
    const { toggleToast } = useToast();
    const [initialValues, setInitialValues] = useState<any>({
      description: null,
    })

    const updateOSOne = async () => {
      try {
        setLoadingUpdateProposal(true)
        const body = {
          description: formik.values.description
        }
        await putProposalOne(itemProposal.id ? itemProposal.id : "", body)
        toggleToast("Sucesso ao atualizar a proposta. ", "success")
        //setClients(MyClient)
  
      } catch (error) {
        console.log(error)
        toggleToast("Erro ao atualizar a proposta. ", "error")
        
      }finally{
        setLoadingUpdateProposal(false)
        refresh()
      }
  }


    const formik = useFormik({
      initialValues,
      validationSchema,
      validateOnChange: false,
      onSubmit: () => {},
    });
  
    const submit = () => {
      updateOSOne()
    }


  useEffect(() => {
    if(itemProposal && itemProposal.description){
      formik.setValues({description: itemProposal.description})
    }
  }, [])

  return (
    <div className='card'>
        <div
          className='card-header border-0 cursor-pointer'
          role='button'
          data-bs-toggle='collapse'
          data-bs-target='#kt_account_profile_details'
          aria-expanded='true'
          aria-controls='kt_account_profile_details'
        >
          <div className='card-title m-0' style={{justifyContent: 'space-between', width: '100%'}}>
            <h3 className='fw-bolder m-0'>Descrição</h3>

            {/* {currentUser && currentUser.role && currentUser.role.slug && currentUser.role.slug !== 'CLIENTE' && 
              <button
                  className='btn btn-lg text-hover-primary'
                  style={{padding: '0rem'}}
                  onClick={(event) => {
                      event.stopPropagation();
                      setShowModalDescriptionOS(true)
                  }}
                  type="button"
              >
                <KTSVG className='svg-icon-muted svg-icon-2hx' path='/media/icons/duotune/general/gen035.svg' />
              </button>
            } */}

          </div>
        </div>

        <div id='kt_account_profile_details' className='collapse show'>
          <div>
            <div className='card-body border-top p-9'>
            <div className='mb-6' style={{display: 'flex', gap: '5rem', alignItems: 'center'}}>

            <div className='col-lg-12'>
                <textarea
                    style={{minHeight: '10rem', width: '100%', resize: 'vertical', whiteSpace: 'pre-wrap'}}
                    className='form-control form-control-lg'
                    name='description'
                    placeholder='Sem descrição'
                    rows={8}
                    value={formik.values.description ? formik.values.description : ""}
                    onChange={formik.handleChange("description")}
                />
            </div>


              {/* <label className='col-form-label fw-bold fs-6'>Descrição </label> */}

              {/* <div>
                <div className='row'>
                  <div className='col-lg-12 fv-row'>
                    <span className='text-muted fw-semibold fs-6'>
                        {itemProposal && itemProposal.description ? itemProposal.description : ""}
                    </span>
                  </div>
                </div>
              </div> */}
            </div>
            </div>


            <div className='card-footer d-flex justify-content-end py-6 px-9'>
              <button
                onClick={submit} 
                disabled={!formik.values.description}
                className='btn btn-primary'>
                {!loading && 'Salvar Descrição'}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Salvando...{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>
          </div>
        </div>

        <ModalDescriptionProposal
          id={itemProposal && itemProposal.id ? itemProposal.id : null}
          refresh={refresh}
          data={itemProposal ? itemProposal : null}
          handleClose={() => {
            setShowModalDescriptionOS(false)
          }}
          show={showModalDescriptionOS}
        />
      </div>
  );
}